import { gql } from '@apollo/client'

export const FETCH_TUTORIALS = gql`
  query tutorials {
    tutorials(sort: "position", pagination: { pageSize: 100 }) {
      data {
        id
        attributes {
          position
          name
          title
          duration
          description
          buttonText
          tutorialGroup {
            data {
              id
              attributes {
                title
                duration
                summary
                kind
              }
            }
          }
          tutorialType
          platform
          sensorKind
          image {
            data {
              id
              attributes {
                url
                previewUrl
              }
            }
          }
        }
      }
    }
  }
`
